<div id="mdrt-status-container" class="container-fluid">
    <!-- Sprinner -->
    @if(this.setSprinner()) {
    <div class="pias-spinner">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    }
  <!-- <div id="mdrt-status-header">
        <h5 class="page-header">MDRT Status</h5>
    </div> -->
  <div id="mdrt-status-dashboard" [hidden]="this.isMdrtStatusDashboardHidden()">
    <div class="row">
      @if(!this.isAffinityUser()){
      <div class="col-12 col-sm-6 col-md-4 mb-3">
        <div id="income-method-card" class="card income-card">
          <!-- Header -->
          <div class="card-header-custom">
            <i class="bx bx-dollar-circle header-icon"></i>
            <span class="card-title"> Income Method (Qualifiers) </span>
          </div>

          <!-- Content -->
          <div class="card-body-custom">
            <div class="column">
              <p class="label">MDRT</p>
              <p class="value">{{this.mdrtStatusIncomeCount.mdrt}}</p>
            </div>

            <div class="divider"></div>

            <div class="column">
              <p class="label">COT</p>
              <p class="value">{{this.mdrtStatusIncomeCount.cot}}</p>
            </div>

            <div class="divider"></div>

            <div class="column">
              <p class="label">TOT</p>
              <p class="value">{{this.mdrtStatusIncomeCount.tot}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 mb-3">
        <div id="commission-method-card" class="card income-card" aria-label="View Qualified Advisors By Income Method">
          <!-- Header -->
          <div class="card-header-custom">
            <i class="bx bx-discount header-icon"></i>
            <span class="card-title"> Commission Method (Qualifiers) </span>
          </div>

          <!-- Content -->
          <div class="card-body-custom">
            <div class="column">
              <p class="label">MDRT</p>
              <p class="value">{{this.mdrtStatusCommissionCount.mdrt}}</p>
            </div>

            <div class="divider"></div>

            <div class="column">
              <p class="label">COT</p>
              <p class="value">{{this.mdrtStatusCommissionCount.cot}}</p>
            </div>

            <div class="divider"></div>

            <div class="column">
              <p class="label">TOT</p>
              <p class="value">{{this.mdrtStatusCommissionCount.tot}}</p>
            </div>
          </div>
        </div>
      </div>
      }
      <div class="col-12 col-sm-6 col-md-4 mb-3">
        <div id="premium-method-card" class="card income-card" aria-label="View Qualified Advisors By Income Method">
          <!-- Header -->
          <div class="card-header-custom">
            <i class="bx bx-wallet-note header-icon"></i>
            <span class="card-title"> Premium Method (Qualifiers) </span>
          </div>

          <!-- Content -->
          <div class="card-body-custom">
            <div class="column">
              <p class="label">MDRT</p>
              <p class="value">{{this.mdrtStatusPremiumCount.mdrt}}</p>
            </div>

            <div class="divider"></div>

            <div class="column">
              <p class="label">COT</p>
              <p class="value">{{this.mdrtStatusPremiumCount.cot}}</p>
            </div>

            <div class="divider"></div>

            <div class="column">
              <p class="label">TOT</p>
              <p class="value">{{this.mdrtStatusPremiumCount.tot}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="ape-card-divider"></div> -->
  <p class="comment-content"><b>Disclaimer:</b> {{this.mdrtDashboardDisclaimer}}</p>
  <mat-divider class="pias-divider" [hidden]="this.isMdrtStatusDashboardHidden()"></mat-divider>

  @if(!this.isAffinityUser()){
  <!-- MDRT Status Income Method -->
  <mat-accordion class="pias-accordian">
    <mat-expansion-panel class="pias-expansion-panel" [expanded]="false">
      <mat-expansion-panel-header class="pias-expansion-panel-header">
        <mat-panel-title class="pias-expansion-panel-title">
          <h5 class="header">Income Method</h5>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <!-- Income Method Data Filtering -->
      <!-- <mat-form-field class="w-100">
                <mat-label>Search Income Method</mat-label>
                <input type="text" matInput [formControl]="mdrtStatusIncomeTableFilterFc"
                    (keyup)="__applyIncomeMethodDataFilter()" placeholder="Ex. Rep. code, name" />
            </mat-form-field> -->
      <div id="mdrt-status-income-method-filter" class="position-relative" style="max-width: 500px"
        [hidden]="this.isMdrtStatusFilterAndPaginatorHidden()">
        <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5" style="background: #f0f0f0; color: #1c3a7a"
          [formControl]="mdrtStatusIncomeTableFilterFc" (keyup)="__applyIncomeMethodDataFilter()"
          placeholder="Search Income Method..." #input />

        <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y" style="color: #888888"></i>

        <button *ngIf="mdrtStatusIncomeTableFilterFc.value"
          class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
          (click)="clearSearch()">
          <i class="fas fa-times" style="color: #888888"></i>
        </button>
      </div>
      <mat-divider class="pias-divider" [hidden]="this.isMdrtStatusFilterAndPaginatorHidden()"></mat-divider>



      <div id="mdrt-status-income-method-table" class="pias-table-container">
        <table mat-table class="pias-table table table-hover table-bordered bg-light border border-2"
          [dataSource]="mdrtStatusIncomeTableDataSource" matSort matSortDisableClear matSortActive="mdrtAchievedGr"
          matSortDirection="desc" #mdrtStatusIncomeTableSort="matSort" multiTemplateDataRows>
          <!-- Rep Code Column -->
          <ng-container matColumnDef="repCode">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold" mat-sort-header>
              Rep. Code
            </th>
            <td mat-cell [attr.rowspan]="3" *matCellDef="let mdrtData" class="text-start align-middle mdrt-td-border-bt"
              style="max-width: 100px;">
              {{ mdrtData.repCode }}
            </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="personName">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold" mat-sort-header>
              Name
            </th>
            <td mat-cell [attr.rowspan]="3" *matCellDef="let mdrtData" class="text-start align-middle mdrt-td-border-bt"
              style="max-width: 150px;">
              {{ mdrtData.personName }}
            </td>
          </ng-container>

          <!-- Branch Column -->
          <ng-container matColumnDef="branch">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold" mat-sort-header>
              Branch
            </th>
            <td mat-cell [attr.rowspan]="3" *matCellDef="let mdrtData" class="text-start align-middle mdrt-td-border-bt"
              style="max-width: 200px;">
              {{ mdrtData.branch }}
            </td>
          </ng-container>

          <!-- Qualification Column -->
          <ng-container matColumnDef="mdrtQualification">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
              Qualification
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="text-center mdrt-cell">
              {{ mdrtData.mdrtQualification }}
            </td>
          </ng-container>

          <!-- Target Column -->
          <ng-container matColumnDef="mdrtTarget">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
              Target
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="text-end mdrt-cell">
              {{ mdrtData.mdrtTarget | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <!-- Achieved GR Column -->
          <ng-container matColumnDef="mdrtAchievedGr">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold" mat-sort-header>
              Achieved
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="text-end mdrt-cell">
              {{ mdrtData.mdrtAchievedGr | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <!-- Shortfall Column -->
          <ng-container matColumnDef="mdrtShortfall">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
              Shortfall
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="text-end mdrt-cell">
              {{ mdrtData.mdrtShortfall | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <!-- Met/Not Met Column -->
          <ng-container matColumnDef="mdrtMetOrNotmet">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
              Met/Not Met
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="d-flex justify-content-center mdrt-cell">
              @if(mdrtData.mdrtMetorNotMet) {
              <span class="target-met">Met</span>
              } @else {
              <span class="target-not-met">Not Met</span>
              }
            </td>
          </ng-container>

          <!-- COT Data Column -->
          <ng-container matColumnDef="cotQualification">
            <td mat-cell *matCellDef="let mdrtData" class="text-center cot-cell">
              {{ mdrtData.cotQualification }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cotTarget">
            <td mat-cell *matCellDef="let mdrtData" class="text-end cot-cell">
              {{ mdrtData.cotTarget | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cotAchievedGr">
            <td mat-cell *matCellDef="let mdrtData" class="text-end cot-cell">
              {{ mdrtData.cotAchievedGr | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cotShortfall">
            <td mat-cell *matCellDef="let mdrtData" class="text-end cot-cell">
              {{ mdrtData.cotShortfall | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cotMetOrNotmet" class="text-center">
            <td mat-cell *matCellDef="let mdrtData" class="d-flex justify-content-center cot-cell">
              @if(mdrtData.cotMetorNotMet) {
              <span class="target-met">Met</span>
              } @else {
              <span class="target-not-met">Not Met</span>
              }
            </td>
          </ng-container>

          <!-- TOT Data Column -->
          <ng-container matColumnDef="totQualification">
            <td mat-cell *matCellDef="let mdrtData" class="text-center tot-cell mdrt-td-border-bt">
              {{ mdrtData.totQualification }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totTarget">
            <td mat-cell *matCellDef="let mdrtData" class="text-end tot-cell mdrt-td-border-bt">
              {{ mdrtData.totTarget | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totAchievedGr">
            <td mat-cell *matCellDef="let mdrtData" class="text-end tot-cell mdrt-td-border-bt">
              {{ mdrtData.totAchievedGr | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totShortfall">
            <td mat-cell *matCellDef="let mdrtData" class="text-end tot-cell mdrt-td-border-bt">
              {{ mdrtData.totShortfall | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totMetOrNotmet" class="text-center">
            <td mat-cell *matCellDef="let mdrtData" class="d-flex justify-content-center tot-cell mdrt-td-border-bt">
              @if(mdrtData.totMetorNotMet) {
              <span class="target-met">Met</span>
              } @else {
              <span class="target-not-met">Not Met</span>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="mdrtStatusIncomeTableDisplayFirstColumn; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: mdrtStatusIncomeTableDisplayFirstColumn"></tr>
          <tr mat-row *matRowDef="let row; columns: mdrtStatusIncomeTableDisplaySecondColumn"></tr>
          <tr mat-row *matRowDef="let row; columns: mdrtStatusIncomeTableDisplayThirdColumn"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="7">No data found.</td>
          </tr>
        </table>
      </div>
      <mat-action-row [hidden]="this.isMdrtStatusFilterAndPaginatorHidden()">
        <mat-paginator #mdrtStatusIncomeTablePaginator [pageSizeOptions]="[10, 20, 50]"
          showFirstLastButtons aria-label="Select page of income by advisor data"></mat-paginator>
      </mat-action-row>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-divider class="pias-divider"></mat-divider>

  <!-- MDRT Status Commission Method -->
  <mat-accordion class="pias-accordian">
    <mat-expansion-panel class="pias-expansion-panel" [expanded]="false">
      <mat-expansion-panel-header class="pias-expansion-panel-header">
        <mat-panel-title class="pias-expansion-panel-title">
          <h5 class="header">Commission Method</h5>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <!-- Commission Method Data Filtering -->
      <!-- <mat-form-field class="w-100">
                <mat-label>Search Commission Method</mat-label>
                <input type="text" matInput [formControl]="mdrtStatusCommissionTableFilterFc"
                    (keyup)="__applyCommissionMethodDataFilter()" placeholder="Ex. Rep. code, name" />
            </mat-form-field> -->
      <div id="mdrt-status-commission-method-filter" class="position-relative" style="max-width: 500px"
        [hidden]="this.isMdrtStatusFilterAndPaginatorHidden()">
        <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5" style="background: #f0f0f0; color: #1c3a7a"
          [formControl]="mdrtStatusCommissionTableFilterFc" (keyup)="__applyCommissionMethodDataFilter()"
          placeholder="Search Commission Method..." #input />

        <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y" style="color: #888888"></i>

        <button *ngIf="mdrtStatusCommissionTableFilterFc.value"
          class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
          (click)="clearCommissionSearch()">
          <i class="fas fa-times" style="color: #888888"></i>
        </button>
      </div>
      <mat-divider class="pias-divider" [hidden]="this.isMdrtStatusFilterAndPaginatorHidden()"></mat-divider>

      <div id="mdrt-status-commission-method-table" class="pias-table-container">
        <table mat-table class="pias-table table table-hover table-bordered bg-light border border-2"
          [dataSource]="mdrtStatusCommissionTableDataSource" matSort mastSortDisableClear matSortActive="mdrtAchievedGr"
          matSortDirection="desc" #mdrtStatusCommissionTableSort="matSort" multiTemplateDataRows>

          <!-- Rep Code Column -->
          <ng-container matColumnDef="repCode">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold" mat-sort-header>
              Rep. Code
            </th>
            <td mat-cell [attr.rowspan]="3" *matCellDef="let mdrtData" class="text-start align-middle mdrt-td-border-bt"
              style="max-width: 100px;">
              {{ mdrtData.repCode }}
            </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="personName">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold" mat-sort-header>
              Name
            </th>
            <td mat-cell [attr.rowspan]="3" *matCellDef="let mdrtData" class="text-start align-middle mdrt-td-border-bt"
              style="max-width: 150px;">
              {{ mdrtData.personName }}
            </td>
          </ng-container>

          <!-- Branch Column -->
          <ng-container matColumnDef="branch">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold" mat-sort-header>
              Branch
            </th>
            <td mat-cell [attr.rowspan]="3" *matCellDef="let mdrtData" class="text-start align-middle mdrt-td-border-bt"
              style="max-width: 200px;">
              {{ mdrtData.branch }}
            </td>
          </ng-container>

          <!-- Qualification Column -->
          <ng-container matColumnDef="mdrtQualification">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
              Qualification
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="text-center mdrt-cell">
              {{ mdrtData.mdrtQualification }}
            </td>
          </ng-container>

          <!-- Target Column -->
          <ng-container matColumnDef="mdrtTarget">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
              Target
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="text-end mdrt-cell">
              {{ mdrtData.mdrtTarget | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <!-- Achieved GR Column -->
          <ng-container matColumnDef="mdrtAchievedGr">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold" mat-sort-header>
              Achieved
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="text-end mdrt-cell">
              {{ mdrtData.mdrtAchievedGr | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <!-- Shortfall Column -->
          <ng-container matColumnDef="mdrtShortfall">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
              Shortfall
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="text-end mdrt-cell">
              {{ mdrtData.mdrtShortfall | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <!-- Met/Not Met Column -->
          <ng-container matColumnDef="mdrtMetOrNotmet">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
              Met/Not Met
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="d-flex justify-content-center mdrt-cell">
              @if(mdrtData.mdrtMetorNotMet) {
              <span class="target-met">Met</span>
              } @else {
              <span class="target-not-met">Not Met</span>
              }
            </td>
          </ng-container>

          <!-- COT Data Column -->
          <ng-container matColumnDef="cotQualification">
            <td mat-cell *matCellDef="let mdrtData" class="text-center cot-cell">
              {{ mdrtData.cotQualification }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cotTarget">
            <td mat-cell *matCellDef="let mdrtData" class="text-end cot-cell">
              {{ mdrtData.cotTarget | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cotAchievedGr">
            <td mat-cell *matCellDef="let mdrtData" class="text-end cot-cell">
              {{ mdrtData.cotAchievedGr | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cotShortfall">
            <td mat-cell *matCellDef="let mdrtData" class="text-end cot-cell">
              {{ mdrtData.cotShortfall | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cotMetOrNotmet" class="text-center">
            <td mat-cell *matCellDef="let mdrtData" class="d-flex justify-content-center cot-cell">
              @if(mdrtData.cotMetorNotMet) {
              <span class="target-met">Met</span>
              } @else {
              <span class="target-not-met">Not Met</span>
              }
            </td>
          </ng-container>

          <!-- TOT Data Column -->
          <ng-container matColumnDef="totQualification">
            <td mat-cell *matCellDef="let mdrtData" class="text-center tot-cell mdrt-td-border-bt">
              {{ mdrtData.totQualification }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totTarget">
            <td mat-cell *matCellDef="let mdrtData" class="text-end tot-cell mdrt-td-border-bt">
              {{ mdrtData.totTarget | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totAchievedGr">
            <td mat-cell *matCellDef="let mdrtData" class="text-end tot-cell mdrt-td-border-bt">
              {{ mdrtData.totAchievedGr | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totShortfall">
            <td mat-cell *matCellDef="let mdrtData" class="text-end tot-cell mdrt-td-border-bt">
              {{ mdrtData.totShortfall | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totMetOrNotmet" class="text-center">
            <td mat-cell *matCellDef="let mdrtData" class="d-flex justify-content-center tot-cell mdrt-td-border-bt">
              @if(mdrtData.totMetorNotMet) {
              <span class="target-met">Met</span>
              } @else {
              <span class="target-not-met">Not Met</span>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="mdrtStatusCommissionTableDisplayFirstColumn; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: mdrtStatusCommissionTableDisplayFirstColumn"></tr>
          <tr mat-row *matRowDef="let row; columns: mdrtStatusCommissionTableDisplaySecondColumn"></tr>
          <tr mat-row *matRowDef="let row; columns: mdrtStatusCommissionTableDisplayThirdColumn"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="7">No data found.</td>
          </tr>
        </table>
      </div>
      <mat-action-row [hidden]="this.isMdrtStatusFilterAndPaginatorHidden()">
        <mat-paginator #mdrtStatusCommissionTablePaginator [pageSizeOptions]="[10, 20, 50]"
          showFirstLastButtons aria-label="Select page of Commission by advisor data"></mat-paginator>
      </mat-action-row>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-divider class="pias-divider"></mat-divider>
  }

  <!-- MDRT Status Premium Method -->
  <mat-accordion class="pias-accordian">
    <mat-expansion-panel class="pias-expansion-panel" [expanded]="false">
      <mat-expansion-panel-header class="pias-expansion-panel-header">
        <mat-panel-title class="pias-expansion-panel-title">
          <h5 class="header">Premium Method</h5>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <!-- Premium Method Data Filtering -->
      <!-- <mat-form-field class="w-100">
                <mat-label>Search Premium Method</mat-label>
                <input type="text" matInput [formControl]="mdrtStatusPremiumTableFilterFc"
                    (keyup)="__applyPremiumMethodDataFilter()" placeholder="Ex. Rep. code, name" />
            </mat-form-field> -->
      <div id="mdrt-status-premium-method-filter" class="position-relative" style="max-width: 500px"
        [hidden]="this.isMdrtStatusFilterAndPaginatorHidden()">
        <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5" style="background: #f0f0f0; color: #1c3a7a"
          [formControl]="mdrtStatusPremiumTableFilterFc" (keyup)="__applyPremiumMethodDataFilter()"
          placeholder="Search Premium Method..." #input />

        <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y" style="color: #888888"></i>

        <button *ngIf="mdrtStatusPremiumTableFilterFc.value"
          class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
          (click)="clearPremiumSearch()">
          <i class="fas fa-times" style="color: #888888"></i>
        </button>
      </div>
      <mat-divider class="pias-divider" [hidden]="this.isMdrtStatusFilterAndPaginatorHidden()"></mat-divider>

      <div id="mdrt-status-premium-method-table" class="pias-table-container">
        <table mat-table class="pias-table table table-hover table-bordered bg-light border border-2"
          [dataSource]="mdrtStatusPremiumTableDataSource" matSort matSortDisableClear matSortActive="mdrtAchievedGr"
          matSortDirection="desc" #mdrtStatusPremiumTableSort="matSort" multiTemplateDataRows>
          <!-- Rep Code Column -->
          <ng-container matColumnDef="repCode">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold" mat-sort-header>
              Rep. Code
            </th>
            <td mat-cell [attr.rowspan]="3" *matCellDef="let mdrtData" class="text-start align-middle mdrt-td-border-bt"
              style="max-width: 100px">
              {{ mdrtData.repCode }}
            </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="personName">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold" mat-sort-header>
              Name
            </th>
            <td mat-cell [attr.rowspan]="3" *matCellDef="let mdrtData" class="text-start align-middle mdrt-td-border-bt"
              style="max-width: 150px">
              {{ mdrtData.personName }}
            </td>
          </ng-container>

          <!-- Branch Column -->
          <ng-container matColumnDef="branch">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold" mat-sort-header>
              Branch
            </th>
            <td mat-cell [attr.rowspan]="3" *matCellDef="let mdrtData" class="text-start align-middle mdrt-td-border-bt"
              style="max-width: 200px">
              {{ mdrtData.branch }}
            </td>
          </ng-container>

          <!-- Qualification Column -->
          <ng-container matColumnDef="mdrtQualification">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
              Qualification
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="text-center mdrt-cell">
              {{ mdrtData.mdrtQualification }}
            </td>
          </ng-container>

          <!-- Target Column -->
          <ng-container matColumnDef="mdrtTarget">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
              Target
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="text-end mdrt-cell">
              {{ mdrtData.mdrtTarget | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <!-- Achieved GR Column -->
          <ng-container matColumnDef="mdrtAchievedGr">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold" mat-sort-header>
              Achieved
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="text-end mdrt-cell">
              {{ mdrtData.mdrtAchievedGr | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <!-- Shortfall Column -->
          <ng-container matColumnDef="mdrtShortfall">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
              Shortfall
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="text-end mdrt-cell">
              {{ mdrtData.mdrtShortfall | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <!-- Met/Not Met Column -->
          <ng-container matColumnDef="mdrtMetOrNotmet">
            <th mat-header-cell *matHeaderCellDef class="text-center align-middle fw-bold">
              Met/Not Met
            </th>
            <td mat-cell *matCellDef="let mdrtData" class="d-flex justify-content-center mdrt-cell">
              @if(mdrtData.mdrtMetorNotMet) {
              <span class="target-met">Met</span>
              } @else {
              <span class="target-not-met">Not Met</span>
              }
            </td>
          </ng-container>

          <!-- COT Data Column -->
          <ng-container matColumnDef="cotQualification">
            <td mat-cell *matCellDef="let mdrtData" class="text-center cot-cell">
              {{ mdrtData.cotQualification }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cotTarget">
            <td mat-cell *matCellDef="let mdrtData" class="text-end cot-cell">
              {{ mdrtData.cotTarget | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cotAchievedGr">
            <td mat-cell *matCellDef="let mdrtData" class="text-end cot-cell">
              {{ mdrtData.cotAchievedGr | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cotShortfall">
            <td mat-cell *matCellDef="let mdrtData" class="text-end cot-cell">
              {{ mdrtData.cotShortfall | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cotMetOrNotmet" class="text-center">
            <td mat-cell *matCellDef="let mdrtData" class="d-flex justify-content-center cot-cell">
              @if(mdrtData.cotMetorNotMet) {
              <span class="target-met">Met</span>
              } @else {
              <span class="target-not-met">Not Met</span>
              }
            </td>
          </ng-container>

          <!-- TOT Data Column -->
          <ng-container matColumnDef="totQualification">
            <td mat-cell *matCellDef="let mdrtData" class="text-center tot-cell mdrt-td-border-bt">
              {{ mdrtData.totQualification }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totTarget">
            <td mat-cell *matCellDef="let mdrtData" class="text-end tot-cell mdrt-td-border-bt">
              {{ mdrtData.totTarget | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totAchievedGr">
            <td mat-cell *matCellDef="let mdrtData" class="text-end tot-cell mdrt-td-border-bt">
              {{ mdrtData.totAchievedGr | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totShortfall">
            <td mat-cell *matCellDef="let mdrtData" class="text-end tot-cell mdrt-td-border-bt">
              {{ mdrtData.totShortfall | currency : 'SGD' : 'symbol-narrow' : '1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totMetOrNotmet" class="text-center">
            <td mat-cell *matCellDef="let mdrtData" class="d-flex justify-content-center tot-cell mdrt-td-border-bt">
              @if(mdrtData.totMetorNotMet) {
              <span class="target-met">Met</span>
              } @else {
              <span class="target-not-met">Not Met</span>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="mdrtStatusPremiumTableDisplayFirstColumn; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: mdrtStatusPremiumTableDisplayFirstColumn"></tr>
          <tr mat-row *matRowDef="let row; columns: mdrtStatusPremiumTableDisplaySecondColumn"></tr>
          <tr mat-row *matRowDef="let row; columns: mdrtStatusPremiumTableDisplayThirdColumn"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="7">No data found.</td>
          </tr>
        </table>
      </div>
      <mat-action-row [hidden]="this.isMdrtStatusFilterAndPaginatorHidden()">
        <mat-paginator #mdrtStatusPremiumTablePaginator [pageSizeOptions]="[10, 20, 50]"
          showFirstLastButtons aria-label="Select page of Premium by advisor data"></mat-paginator>
      </mat-action-row>
    </mat-expansion-panel>
  </mat-accordion>
</div>